<template>
  <div>
    <div style="margin-top:20px;" v-if="showForm">
      <Loading :isLoading="this.isLoading"/>
      <div class="description">
        <p>{{description}}</p>
      </div>
      <form @submit="authenticate">
        <div class="mb-4">
          <label for="" class="titleInputs">R.F.C.:</label><br/>
          <input class="inputsForm upperCaseTransform" id="input_rfc" type="text" v-model.trim="$v.rfc.$model" 
            :class="{'inputs-invalid-form':$v.rfc.$error, 'inputsForm':!$v.rfc.$invalid}" pattern="[a-zA-Z-0-9]{0,13}" 
            placeholder="Ingresar R.F.C.">
          <div class="content-text">
            <div v-if="$v.rfc.$error" class="text">
              <span class="errors" v-if="!$v.rfc.required">El rfc es requerido</span>
              <span class="errors" v-if="!$v.rfc.minLength">Debe ingresar los 13 caracteres del rfc</span>
              <span class="errors" v-if="!$v.rfc.maxLength">Debe ingresar los 13 caracteres del rfc</span>
            </div>
          </div>
        </div>
        <div class="mb-4" v-if="askNip">
          <label for="" class="titleInputs">NIP:</label><br/>
          <input class="inputsForm" id="input_nip" type="password" v-model="$v.nip.$model" placeholder="Ingresar NIP"
            :class="{'inputs-invalid-form':$v.nip.$error, 'inputsForm':!$v.nip.$invalid}" />
          <div class="content-text">
            <div v-if="$v.nip.$error" class="text">
              <span class="errors" v-if="!$v.nip.required">El nip es requerido</span>
              <span class="errors" v-if="!$v.nip.minLength">Debe ingresar los 4 caracteres del nip</span>
              <span class="errors" v-if="!$v.nip.maxLength">Debe ingresar los 4 caracteres del nip</span>
            </div>
          </div>
        </div>
        <div>
          <button class="AccessButton" id="button_consult">Consultar</button>
        </div>
        <div style="margin-top:10px" v-if="showBackButton">
          <div>
            <input type="button" value="Atrás" v-on:click="goBack()" class="AccessButtonWithoutBackground" id="backButton" />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Loading from '@/components/Loading/Loading.vue'
import User from '@/classes/User'
import {required, minLength, maxLength, requiredIf} from 'vuelidate/lib/validators'

import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      rfc: "",
      nip: "",
      isLoading: false,
      userObjectClass: null,
      response: {
        rfcIsValid: false,
        data: {}
      },
    }
  },
  validations: {
    rfc: {
      required,
      minLength: minLength(13),
      maxLength: maxLength(13)
    },
    nip: {
      required: requiredIf(function() {
        return this.askNip;
      }),
      minLength: minLength(4),
      maxLength: maxLength(4)
    }
  },
  name: "PersonalInformationPreRequestLoan",
  props: {
    tokenAuth: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: "",
    },
    askNip: {
      type: Boolean,
      default: true
    },
    showForm: {
      type: Boolean,
      default: true
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    backUrl: {
      type: String,
      default: 'Home'
    }
  },
  components: {
    Loading
  },
  watch: {
    rfc(value) {
      var regex = /[^a-z0-9]/gi
      if (this.rfc.toString().length > 13) {
        this.rfc = this.rfc.toString().slice(0, -1);
      } else {
        if (regex.test(value)) {
          this.rfc = this.rfc.toString().slice(0, -1);
        }
      }
    },
    nip(value) {
      var regex = /^([0-9])*$/
      if (this.nip.toString().length > 4) {
        this.nip = this.nip.toString().slice(0, -1);
      } else {
        if (!regex.test(value)) {
          this.nip = this.nip.toString().slice(0, -1);
        }
      }
    }
  },
  mounted() {
    this.userObjectClass = new User();
  },
  methods: {
    authenticate(e) {
      e.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoading = true;
        this.userObjectClass.validateRFC(this.rfc).then(response => {
          if (this.askNip) {
            this.searchByRfcAndNip().then(response => {
              this.isLoading = false;
              if (response.data.response.message == "autenticación exitosa") {
                this.response.rfcIsValid = true;
                this.response.data = response.data.response.authenticate;
              } else {
                this.isLoading = false;
                this.response.rfcIsValid = false;
                Swal.fire({
                  title: "Aviso",
                  text: "R.F.C o NIP Invalidos",
                  icon: "error",
                })
              }

              this.$emit('search-info-by-rfc-nip', this.response);
            }).catch(error => {
              this.isLoading = false;
              this.response.rfcIsValid = false;
              Swal.fire({
                title: "Aviso",
                text: error,
                icon: "error",
              })

              this.$emit('search-info-by-rfc-nip', this.response);
            });
          }

          if (!this.askNip) {
            this.searchByRfc().then(response => {
              this.isLoading = false;
              if (response.data.response.message == "consulta exitosa") {
                this.response.rfcIsValid = true;
                this.response.data = response.data.response.member;
              } else {
                this.isLoading = false;
                this.response.rfcIsValid = false;
                Swal.fire({
                  title: "Aviso",
                  text: "R.F.C o NIP Invalidos",
                  icon: "error",
                })
              }

              this.$emit('search-info-by-rfc-nip', this.response);
            }).catch(error => {
              this.isLoading = false;
              this.response.rfcIsValid = false;
              Swal.fire({
                title: "Aviso",
                text: error,
                icon: "error",
              })

              this.$emit('search-info-by-rfc-nip', this.response);
            });
          }
        }).catch(error =>{
          this.isLoading = false;
          this.response.rfcIsValid = false;
          this.showMessage();

          this.$emit('search-info-by-rfc-nip', this.response);
        }); 
      }
    },
    async searchByRfcAndNip() {
      return await this.userObjectClass.authenticate(this.rfc, this.nip).then(response => {
        return response;
      }).catch(error => {
        throw error;
      });
    },
    async searchByRfc() {
      return await this.userObjectClass.authenticateByRfc(this.tokenAuth, this.rfc).then(response => {
        return response;
      }).catch(error => {
        throw error;
      });
    },
    showMessage() {
      Swal.fire({
        title: "Aviso",
        width: 600,
        text: "Para poder continuar el RFC debe cumplir ",
        html: `<p style="font-size:18px;font-family:Roboto;">Para poder continuar con el proceso el RFC debe cumplir con lo siguiente:</p> <br/>
              <span style="font-size:18px;font-family:Roboto;font-weight:bold;">DATO DE 13 CARACTERES ALFANUMERICOS MAXIMO, COMPUESTO POR: </span>
              <br/>
              <br/>
              <ul style="list-style: circle;text-align:left;font-size:14px;font-family:Roboto;">
                <li>CUATRO LETRAS</li>
                <li>SEIS CARACTERES NUMERICOS QUE CORRESPONDEN A LA FECHA, (DOS CARACTERES PARA
                  AÑO, DOS PARA MES Y DOS PARA EL DIA).
                </li>
                <li>TRES CARACTERES ALFANUMERICOS PARA LA HOMOCLAVE.</li>
                <li>ESTE DATO NO PODRA CONTENER SIGNOS ESPECIALES (COMAS, CORCHETES, PARENTESIS, ETC.).
                </li>
              </ul>`,
        icon: "warning",
      });
    },
    cleanFields() {
      this.rfc = "";
      this.nip = "";
      this.$v.$reset()
    },
    goBack() {
      this.$router.push({ name: this.backUrl });
    }
  }
}
</script>

<style scoped>

</style>
